import React from "react";

const NotFound = (props) => (
  <div className="min-h-screen flex items-center justify-center flex-col">
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
    <h1 className="text-3xl">404 not found :)</h1>
  </div>
);

export default NotFound;
